<script>
import Layout from "@/router/layouts/main";
import { FormWizard, TabContent } from "vue-form-wizard";

export default {
  name: "create-store-instruction",
  components: {
    Layout,
    FormWizard,
    TabContent
  },
  data() {
    return {
      title: "GIAN HÀNG TRỰC TUYẾN",
      currentImg: 0,
      dataPermission: JSON.parse(localStorage.getItem("dataPermission"))
    };
  },
  methods: {
    checkIndex(data) {
      this.currentImg = data;
    },
    async skipStep(){
      // router push here
      await this.$router.push({ path: "/setting/create-online-store" });
    }
  },
};
</script>

<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_ONLINE_STORE_VIEW')">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <h5 class="mb-2">
                  <b>Hướng dẫn khởi tạo và thiết lập gian hàng trực tuyến</b>
                </h5>
                <p>Khởi tạo trang bán hàng và thiết lập thông tin gian hàng trực tuyến
                </p>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-lg-5 text-center">
                <span v-show="currentImg == 0"><img src="@/assets/images/instruction-step1.png"></span>
                <span v-show="currentImg == 1"><img src="@/assets/images/instruction-step2.png"></span>
                <span v-show="currentImg == 2"><img src="@/assets/images/instruction-step3.png"></span>
              </div>
              <div class="col-lg-7 instruction-steps">
                <form-wizard color="#34c38f" @update:startIndex="checkIndex">
                  <tab-content title="Thông tin gian hàng">
                    <div class="row">
                      <div class="col-lg-7">
                        <div class="step-description">
                          <h4><b>Thiết lập thông tin gian hàng trực tuyến</b></h4>
                          <ul>
                            <li>Tên và mô tả gian hàng</li>
                            <li>Logo gian hàng</li>
                            <li>Địa chỉ và thông tin liên hệ</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content title="Sản phẩm đăng bán">
                    <div class="row">
                      <div class="col-lg-7">
                        <div class="step-description">
                          <h4><b>Lựa chọn sản phẩm đăng bán</b></h4>
                          <ul>
                            <li>Lựa chọn sản phẩm từ danh sách</li>
                            <li>Lựa chọn phiên bản phù hợp</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content title="Thiết lập thanh toán">
                    <div class="row">
                      <div class="col-lg-7">
                        <div class="step-description">
                          <h4><b>Thiết lập phương thức thanh toán</b></h4>
                          <ul>
                            <li>Lựa chọn phương thức thanh toán chấp nhận tại gian hàng</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </tab-content>
                  <template slot="prev">
                    <b-button variant="outline-dark">Trở lại</b-button>
                  </template>

                  <template slot="next">
                    <b-button variant="outline-primary" @click.stop="skipStep()">Bỏ qua</b-button>
                    <b-button variant="primary">Tiếp tục</b-button>
                  </template>

                  <template slot="finish">
                    <b-button variant="primary" @click.stop="skipStep()">Hoàn thành</b-button>
                  </template>
                </form-wizard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>

<style></style>
